export const stats = {
  table: {
    field: {
      campaign: 'Kampanye',
      campaign_id: 'Kampanye ID',
      task_number: 'Jumlah Task',
      src: 'Outgoing',
      dst: 'Incoming',
      date_time: 'Tanggal and waktu',
      duration: 'Durasi',
      client_action: 'Tindakan klien',
      cost: 'Biaya',
      status: 'Status'
    }
  },

  filter: {
    campaign: '@:autoinformer.stats.table.field.campaign',
    status: '@:autoinformer.stats.table.field.status',
    task_number: '@:autoinformer.stats.table.field.task_number',
    src: '@:autoinformer.stats.table.field.src',
    dst: '@:autoinformer.stats.table.field.dst',
    client_action: '@:autoinformer.stats.table.field.client_action'
  },

  state: {
    ANSWERED: 'Terjawab',
    NO_ANSWER: 'Tidak terjawab',
    FAILED: 'Gagal',
    PROGRESS: 'Kemajuan',
    SUBSCRIBER_ABSENT: 'Pelanggan tidak hadir',
    CALL_TIMED_OUT: 'Waktu habis',
    CLIENT_DROPPED_CALL_OR_BUSY: 'Klien membatalkan panggilan atau sibuk',
    NO_HUMAN: 'Mesin penjawab',
  }
};
